import AxiosManager from "../alimtalkAxios";

export async function postKakaoChannel() {
  const res = await AxiosManager.getInstance().post(
    "https://kakaoapi.aligo.in/akv10/profile/list",
    {
      apikey: "hni1zx5bh8sku2no42kuejegpchqknih",
      userid: "josangnim",
    },
  );

  return res;
}

export async function postTemplate(senderkey: string) {
  const res = await AxiosManager.getInstance().post(
    "https://kakaoapi.aligo.in/akv10/template/list",
    {
      apikey: "hni1zx5bh8sku2no42kuejegpchqknih",
      userid: "josangnim",
      senderkey,
    },
  );

  return res;
}

export async function postSendMsg({
  senderkey,
  tpl_code,
  receiver,
  subject,
  message,
  button,
}: any) {
  const res = await AxiosManager.getInstance().post(
    "https://kakaoapi.aligo.in/akv10/alimtalk/send",
    {
      apikey: "hni1zx5bh8sku2no42kuejegpchqknih",
      userid: "josangnim",
      senderkey,
      tpl_code,
      sender: "16683572",
      receiver_1: receiver,
      subject_1: subject,
      message_1: message,
      button_1: button,
    },
  );

  return res;
}
